import { Icon, IconName } from '@mgmresorts/mgm-ui';
import React from 'react';

import { useContent } from '../../../hooks/useContent';
import { useMobile } from '../../../hooks/useMediaQuery';

import {
  StyledBannerDescription,
  StyledBannerImage,
  StyledBannerContent,
  StyledBannerTitle,
  StyledBannerRow,
  StyledIconWrapper,
  StyledDivider,
} from './styles';

type PromoBannerContent = {
  image: {
    src: string;
    alt: string;
  };
  title: string;
  body: Array<{ icon: IconName; description: string }>;
};

export function MGMRewardsPromoBanner() {
  const isMobile = useMobile();
  const { getContentByPath } = useContent();
  const { image, title, body } = getContentByPath('mgmRewardsPromoBanner') as PromoBannerContent;
  return (
    <>
      {isMobile && <StyledDivider direction='horizontal' inverted={false} />}
      <StyledBannerImage src={image.src} alt='' />

      <StyledBannerContent>
        <StyledBannerTitle variant='heading-medium-1' as='h2'>
          {title}
        </StyledBannerTitle>
        {body?.length > 0 &&
          body.map(({ icon, description }, index) => (
            <StyledBannerRow key={index}>
              <StyledIconWrapper>
                <Icon name={icon} size='small' variant='outlined' />
              </StyledIconWrapper>
              <StyledBannerDescription variant='body-regular-m'>{description}</StyledBannerDescription>
            </StyledBannerRow>
          ))}
      </StyledBannerContent>
    </>
  );
}

MGMRewardsPromoBanner.displayName = 'MGMRewardsPromoBanner';
